<template>
  <div class="w-100 h-100 d-flex">
    <div
      class="card text-center px-1 py-2 m-auto"
      style="width:25rem;"
    >
      <img
        class="card-img-top py-3 px-5"
        src="../assets/images/logo-aequaroma.jpg"
        alt="AEqua Roma"
      >
      <div class="text-center my-2">
        Servizi per gli utenti del Patrimonio Immobiliare di Roma Capitale
      </div>
      <div class="d-flex flex-column card-body">
        <h2 class="card-title text-uppercase">
          Accesso non autorizzato
        </h2>
        <p><img src="../assets/images/unauthorized.png"></p>
        <a
          class="btn btn-primary btn-lg text-white mt-2"
          @click="logout"
        >
          Vai alla pagina principale
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    async logout () {
      await this.$store.dispatch('logout')
      console.log('Logout !!')
      // this.$router.push({ name: 'login' })
      this.$router.push({ path: '/entrata' })
    }
  }
}
</script>
